module.exports = __webpack_public_path__ + "img/Wp_2009.4b92f6ab.png";